<template>
  <div class="text-audit-container">
    <el-row :gutter="20">
      <el-col :span="10">
        <el-card shadow="never" class="config-card">
          <div slot="header" class="clearfix">
            <span class="card-title"><i class="el-icon-edit-outline"></i> 任务配置</span>
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              icon="el-icon-refresh-left"
              @click="handleReset"
            >清空内容</el-button>
          </div>

          <el-form label-position="top">
            <el-form-item label="分析类型 (Select Task)">
              <el-radio-group v-model="api" size="medium" class="full-width-radio">
                <el-radio-button :label="summarizeApi">
                  <i class="el-icon-document-copy"></i> 文本摘要
                </el-radio-button>
                <el-radio-button :label="tagApi">
                  <i class="el-icon-collection-tag"></i> 关键词提取
                </el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="分析文本 (Input Content)">
              <el-input
                type="textarea"
                :rows="16"
                placeholder="在此处粘贴或输入需要分析的长文本内容..."
                v-model="textContent"
                maxlength="5000"
                show-word-limit
                resize="none"
              ></el-input>
            </el-form-item>

            <el-button
              type="primary"
              class="analyze-btn"
              :loading="submitting"
              :disabled="!textContent.trim() || !api"
              @click="submitTextAnalysis"
            >
              {{ submitting ? '正在深度分析中...' : '开始 AI 文本分析' }}
            </el-button>
          </el-form>
        </el-card>
      </el-col>

      <el-col :span="14">
        <el-card v-if="analysisResult" shadow="never" class="result-card">
          <div slot="header" class="card-header-flex">
            <div class="header-left">
              <span class="card-title"><i class="el-icon-data-analysis"></i> 分析结果</span>
            </div>
            <el-tag v-if="analysisResult.model_name" class="custom-model-tag">
              <i class="el-icon-monitor"></i> {{ analysisResult.model_name }}
            </el-tag>
          </div>

          <div class="analysis-output">
            <div v-if="analysisResult.prompt" class="prompt-echo">
              <i class="el-icon-guide"></i>
              <span class="echo-text"><strong>AI 指令：</strong>{{ analysisResult.prompt }}</span>
            </div>

            <div class="result-main-box">
              <div class="result-header">
                <span class="title">AI 响应正文</span>
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  icon="el-icon-document-copy"
                  @click="handleCopy(analysisResult.result)"
                >复制结果</el-button>
              </div>

              <div class="result-content-area">
                <div class="text-display-wrapper">
                  <p class="text-display">{{ analysisResult.result }}</p>
                </div>
              </div>
            </div>

            <div class="result-footer m-t-20">
              <el-descriptions size="mini" :column="2" border>
                <el-descriptions-item label="字符数">{{ textContent.length }}</el-descriptions-item>
                <el-descriptions-item label="处理耗时">{{ analysisResult.elapsed_time || '---' }}ms</el-descriptions-item>
              </el-descriptions>
            </div>
          </div>
        </el-card>

        <el-empty
          v-else
          :image-size="200"
          description="等待输入中..."
        >
          <template #description>
            <p class="empty-tip">{{ !api ? '请先选择上方的分析任务类型' : '请在左侧输入需要分析的文本内容' }}</p>
          </template>
        </el-empty>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'TextAudit',
  data() {
    return {
      submitting: false,
      textContent: '',
      analysisResult: null,
      api: '/api1/text/summarize',
      summarizeApi: '/api1/text/summarize',
      tagApi: '/api1/text/tag'
    };
  },
  methods: {
    async submitTextAnalysis() {
      this.submitting = true;
      try {
        const response = await axios.post(this.api, {
          text: this.textContent
        });
        this.analysisResult = response.data;
        this.$message({
          message: '分析成功',
          type: 'success',
          customClass: 'message-on-top'
        });
      } catch (error) {
        this.$message.error('分析失败，请检查网络或文本长度');
      } finally {
        this.submitting = false;
      }
    },
    handleReset() {
      this.textContent = '';
      this.analysisResult = null;
    },
    async handleCopy(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$message.success('已成功复制结果');
      } catch (err) {
        this.$message.error('浏览器拒绝访问剪贴板');
      }
    }
  }
};
</script>

<style scoped>
.text-audit-container {
  padding: 0; /* 在 AuditIndex 已经有 padding 的情况下设为 0 */
}

/* 卡片标题统一 */
.card-title {
  font-weight: 600;
  color: #303133;
  font-size: 15px;
}
.card-title i {
  margin-right: 6px;
  color: #409EFF;
}

/* 按钮行样式 */
.full-width-radio {
  display: flex;
  width: 100%;
}
.full-width-radio >>> .el-radio-button {
  flex: 1;
}
.full-width-radio >>> .el-radio-button__inner {
  width: 100%;
}

.analyze-btn {
  width: 100%;
  margin-top: 10px;
  height: 45px;
  font-size: 16px;
  letter-spacing: 1px;
}

/* 结果展示区优化 */
.card-header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.prompt-echo {
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  background: #fdf6ec;
  border-radius: 8px;
  margin-bottom: 20px;
}
.prompt-echo i {
  color: #e6a23c;
  margin-top: 3px;
  margin-right: 8px;
}
.echo-text {
  font-size: 13px;
  line-height: 1.5;
  color: #606266;
}

.result-main-box {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f8f9fb;
  border-bottom: 1px solid #e4e7ed;
}

.result-content-area {
  padding: 24px;
  background: #fff;
  min-height: 300px;
}

.text-display {
  line-height: 1.8;
  color: #2c3e50;
  font-size: 15px;
  white-space: pre-wrap;
  margin: 0;
}

/* 空状态提示文字 */
.empty-tip {
  color: #909399;
  font-size: 14px;
}

/* 之前页面保持的科技感标签 */
.custom-model-tag {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white !important;
  border: none;
  font-weight: bold;
  padding: 0 12px;
  height: 28px;
  line-height: 26px;
  border-radius: 14px;
}

.m-t-20 { margin-top: 20px; }
</style>
